import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage, FormattedDate } from 'react-intl';
import shiftTimezone from 'tz-offsets';
import classNames from 'classnames';
import { CANCELLATION_FLYWHEEL } from 'constants/cancellation-types';
import { messages } from './CancellationPolicy.messages';
export var CancellationPolicyEarly = function CancellationPolicyEarly(_ref) {
  var isTopUp = _ref.isTopUp,
      endOfCycleDate = _ref.endOfCycleDate,
      msaTimeZone = _ref.msaTimeZone,
      cancellationPolicy = _ref.cancellationPolicy,
      children = _ref.children;
  var cancellationMessage = cancellationPolicy === CANCELLATION_FLYWHEEL ? messages.earlyFlywheel : messages.earlyDefault;
  return React.createElement(Fragment, null, children, React.createElement("div", {
    className: classNames({
      'reservation--top-up__cancellation-policy__early': isTopUp,
      'reservation--inquiry__cancellation-policy__early': !isTopUp
    })
  }, React.createElement(FormattedHTMLMessage, cancellationMessage), isTopUp && React.createElement(FormattedMessage, _extends({}, messages.earlyNonRefundable, {
    values: {
      date: React.createElement(FormattedDate, {
        value: shiftTimezone(endOfCycleDate, msaTimeZone) * 1000,
        month: "long",
        day: "numeric",
        year: "numeric"
      })
    }
  }))));
};
CancellationPolicyEarly.propTypes = {
  isTopUp: PropTypes.bool.isRequired,
  endOfCycleDate: PropTypes.number.isRequired,
  msaTimeZone: PropTypes.string.isRequired,
  cancellationPolicy: PropTypes.string.isRequired,
  children: PropTypes.object
};